import React from 'react';
import fr from 'facet-rest';
import { navigateTo } from 'Helpers/Redirect';
import { changePasswordPath } from 'Consts/Strings';
import useHomeContext from 'Context/HomeContext';
import { FDSecondaryActionButton } from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';

export const NavigateToPasswordResetButton = () => {
  const { homeResource } = useHomeContext();

  return homeResource.withRelationship(fr.relationships.resetPassword.name, (rel) => {
    return (
      <FDSecondaryActionButton
        {...dataAttrs('authentication-forgot-password-button')}
        onClick={() => navigateTo(changePasswordPath)}
        label={rel.meta('prompt')}
      />
    );
  }, () => null);
};
